import { render, staticRenderFns } from "./IdentityForm.vue?vue&type=template&id=5fa9d8ab&scoped=true"
import script from "./IdentityForm.vue?vue&type=script&lang=ts"
export * from "./IdentityForm.vue?vue&type=script&lang=ts"
import style0 from "./IdentityForm.vue?vue&type=style&index=0&id=5fa9d8ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa9d8ab",
  null
  
)

export default component.exports